"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _lodash = require("lodash");

var _MenuRender = _interopRequireDefault(require("./Theme7/MenuRender"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FixedLevel = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(FixedLevel, _React$PureComponent);

  function FixedLevel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      init: false,
      category: null,
      level1: [],
      level2: [],
      pano: [],
      selecteLevel1Id: null,
      selecteLevel2Id: null,
      selectePanoId: null,
      seenScenes: []
    });

    _defineProperty(_assertThisInitialized(_this), "initData", function () {
      clearTimeout(_this.delayTimeout);
      _this.delayTimeout = setTimeout(function () {
        var _this$props = _this.props,
            originalCategory = _this$props.originalCategory,
            scenes = _this$props.scenes;
        var res = (0, _utils.initData)(originalCategory, scenes);

        _this.updateSelected(res.data);
      }, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "updateSelected", function (category) {
      if (!category) {
        category = _this.state.category;
      }

      var scenesId = _this.props.scenesId;
      var selectedAll = (0, _utils.initSelected2)(category, scenesId);

      if (selectedAll.length === 3) {
        var selecteLevel1 = category.find(function (row) {
          return row.id === selectedAll[0];
        });
        var level2 = selecteLevel1.children;
        var selecteLevel2 = level2.find(function (row) {
          return row.id === selectedAll[1];
        });
        var pano = selecteLevel2.children;

        _this.setState({
          level1: category,
          level2: level2,
          pano: pano,
          selecteLevel1Id: selectedAll[0],
          selecteLevel2Id: selectedAll[1],
          selectePanoId: selectedAll[2],
          category: category,
          init: true
        }, _this.tipRebuild);
      } else if (selectedAll.length === 2 || selectedAll.length === 1) {
        var _selecteLevel = category.find(function (row) {
          return row.id === selectedAll[0];
        });

        var _pano = _selecteLevel.children;

        _this.setState({
          level1: category,
          level2: [],
          pano: _pano,
          selecteLevel1Id: selectedAll[0],
          selecteLevel2Id: null,
          selectePanoId: selectedAll[1],
          category: category,
          init: true
        }, _this.tipRebuild);
      } // this.setState({ category, init: true, selectedAll }, this.tipRebuild);

    });

    _defineProperty(_assertThisInitialized(_this), "onClickLevel1", function (id) {
      var switchCategoryShowFirstScene = _this.props.switchCategoryShowFirstScene;
      var _this$state = _this.state,
          level1 = _this$state.level1,
          selecteLevel2Id = _this$state.selecteLevel2Id;
      var selecteLevel1 = level1.find(function (row) {
        return row.id === id;
      });
      var children = selecteLevel1.children;
      var level2 = null;
      var pano = null;

      if (children[0].children) {
        level2 = children;
        var index = level2.findIndex(function (row) {
          return row.id === selecteLevel2Id;
        });
        if (index < 0) index = 0;
        pano = level2[index].children;

        _this.setState({
          selecteLevel1Id: id,
          level2: level2,
          pano: pano
        });
      } else {
        pano = children;
      }

      if (switchCategoryShowFirstScene === 1) {
        _this.onClickPano(pano[0].id);
      } else {
        _this.setState({
          selecteLevel1Id: id,
          level2: level2,
          pano: pano
        }, _this.tipRebuild);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickLevel2", function (id) {
      var switchCategoryShowFirstScene = _this.props.switchCategoryShowFirstScene;
      var level2 = _this.state.level2;
      var selecteLevel2 = level2.find(function (row) {
        return row.id === id;
      });
      var pano = selecteLevel2.children;

      if (switchCategoryShowFirstScene === 1) {
        _this.onClickPano(pano[0].id);
      } else {
        _this.setState({
          selecteLevel2Id: id,
          pano: pano
        }, _this.tipRebuild);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPano", function (id) {
      var onSceneChange = _this.props.onSceneChange;
      onSceneChange && onSceneChange(id);
    });

    _defineProperty(_assertThisInitialized(_this), "setSeenScenes", function (selected) {
      var seenScenes = [].concat(_this.state.seenScenes);

      if (seenScenes.indexOf(selected) < 0) {
        seenScenes.push(selected);

        _this.setState({
          seenScenes: seenScenes
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "tipRebuild", function () {
      var disableTip = _this.props.disableTip;
      if (disableTip) return;

      _reactTooltip["default"].rebuild();
    });

    _defineProperty(_assertThisInitialized(_this), "renderTheme", function () {
      var templateId = _this.props.templateId;
      var _this$props2 = _this.props,
          disableTip = _this$props2.disableTip,
          isShow = _this$props2.isShow,
          THUMB_DOMAIN = _this$props2.THUMB_DOMAIN,
          imgSuffix = _this$props2.imgSuffix,
          ui = _this$props2.ui,
          onOpen = _this$props2.onOpen,
          onClose = _this$props2.onClose,
          buttonTitle = _this$props2.buttonTitle,
          language = _this$props2.language,
          isHide = _this$props2.isHide,
          selectedChangeResize = _this$props2.selectedChangeResize,
          scenesId = _this$props2.scenesId,
          style = _this$props2.style;
      var _this$state2 = _this.state,
          category = _this$state2.category,
          animation = _this$state2.animation,
          seenScenes = _this$state2.seenScenes,
          level1 = _this$state2.level1,
          level2 = _this$state2.level2,
          pano = _this$state2.pano,
          selecteLevel1Id = _this$state2.selecteLevel1Id,
          selecteLevel2Id = _this$state2.selecteLevel2Id;
      var props = {
        style: style,
        category: category,
        level1: level1,
        level2: level2,
        pano: pano,
        selecteLevel1Id: selecteLevel1Id,
        selecteLevel2Id: selecteLevel2Id,
        scenesId: scenesId,
        isShow: isShow,
        THUMB_DOMAIN: THUMB_DOMAIN,
        imgSuffix: imgSuffix,
        disableTip: disableTip,
        animation: animation,
        seenScenes: seenScenes,
        onClickLevel1: _this.onClickLevel1,
        onClickLevel2: _this.onClickLevel2,
        onClickPano: _this.onClickPano,
        ui: ui,
        onOpen: onOpen,
        onClose: onClose,
        buttonTitle: buttonTitle,
        language: language,
        isHide: isHide,
        selectedChangeResize: selectedChangeResize
      };

      if (templateId === 7) {
        return /*#__PURE__*/_react["default"].createElement(_MenuRender["default"], props);
      }
    });

    return _this;
  }

  var _proto = FixedLevel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initData();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props3 = this.props,
        scenesId = _this$props3.scenesId,
        scenes = _this$props3.scenes,
        originalCategory = _this$props3.originalCategory;
    var prevScenesId = prevProps.scenesId,
        prevScenes = prevProps.scenes,
        prevOriginalCategory = prevProps.originalCategory;

    if (!(0, _lodash.isEqual)(scenes, prevScenes) || !(0, _lodash.isEqual)(originalCategory, prevOriginalCategory)) {
      this.initData();
    } else if (scenesId !== prevScenesId) {
      this.updateSelected();
      this.setSeenScenes(prevScenesId);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.delayTimeout);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        style = _this$props4.style,
        templateId = _this$props4.templateId;
    var init = this.state.init;
    if (!init) return null;
    return /*#__PURE__*/_react["default"].createElement("div", null, this.renderTheme());
  };

  return FixedLevel;
}(_react["default"].PureComponent);

var _default = FixedLevel;
exports["default"] = _default;
module.exports = exports.default;